import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import usePlainSecondaryCtaStyles from 'bento-ordering/base/style_hooks/usePlainSecondaryCtaStyles';

const formatPhone = (phone = '') =>
  phone.replace(
    /(\d{3})(\d{3})(\d{4})/gi,
    (match, p1, p2, p3) => `(${p1}) ${p2}-${p3}`
  );

const PhoneAnchor = ({ number, countryCode, dataTestId }) => {
  const styles = usePlainSecondaryCtaStyles();
  return (
    <SecondaryCta
      label={<Typography>{formatPhone(number)}</Typography>}
      classes={styles}
      component="a"
      href={`tel:${countryCode}-${number}`}
      dataTestId={dataTestId}
    />
  );
};

PhoneAnchor.propTypes = {
  number: PropTypes.string,
  countryCode: PropTypes.number,
  dataTestId: PropTypes.string
};

PhoneAnchor.defaultProps = {
  countryCode: 1
};
export default PhoneAnchor;
